import DurationService from "app/services/DurationService";
import { SizeAndGrowthPeriodOverPeriod } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth-period-over-period/SizeAndGrowthPeriodOverPeriod";
import { SizeAndGrowth } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth/SizeAndGrowth";
import styled from "styled-components";
import { Box } from "@similarweb/ui-components";
import { useMemo } from "react";
import { useCurrentStateAndParams } from "@uirouter/react";

const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: initial;
`;

export const SizeAndGrowthOverview = () => {
    const { params } = useCurrentStateAndParams();
    const { duration, comparedDuration } = params;
    const SizeAndGrowthComponent = useMemo(
        () => (DurationService.isPeriodOverPeriod() ? SizeAndGrowthPeriodOverPeriod : SizeAndGrowth),
        [duration, comparedDuration],
    );
    return (
        <Container>
            <SizeAndGrowthComponent />
        </Container>
    );
};
